const $applyBtn = $('.submit-ecommerce-apply')
const $applyTxt = $('.apply-now-fill-text')
const $colForm = $('.block-ecommerce-apply-now .col-form')

$('body').on('click', '.submit-ecommerce-apply', function (e) {
  e.preventDefault()

  $('.block-ecommerce-apply-now form input[type="submit"]')[0].click()

})

$('body').on('submit', '.block-ecommerce-apply-now form', function () {

  $('#apply-now-form-wrapper').hide()

  setTimeout(function () {
    if($('.submitted-message').length) {
      $applyBtn.fadeOut()
      $applyTxt.fadeOut()
      $colForm.addClass('is-submitted')
      $('#apply-now-thank-you').show()

      const scrollBlock = document.getElementById("apply-now-form")
      scrollBlock.scrollIntoView({behavior: 'smooth'}, true)
    } else {
      $('#apply-now-form-wrapper').show()
    }
  }, 1000)


})

setTimeout(function () {
  $('#apply-now-form').find('.hs-submit input').val('Apply now')
},500)

